import React, {useState, useEffect} from 'react'
import { connect } from 'react-redux'
import { fetch } from '../actions'
import { Button, Modal, Skeleton} from 'antd'

function ModalAux(props) {
   
    const {WrappedDet, id, url, modelo, fetch, onCancel} = props;
    const [dadosDet, setDadosDet] = useState(null);
    const [modalPrdVisible, setModalPrdVisible] = useState(false);

    const cancel = () => {
        onCancel(); 
        setModalPrdVisible(false);
    }

    useEffect(() => {

        if(!id && id !== 0){
            setModalPrdVisible(false);
        }
        else if(id != null && id >= 0){

                setDadosDet(null);
                setModalPrdVisible(true);

                fetch().post(url, { modelo, id: id })
                .then(function (response) {
                    let dados = response.data;

                    if(!dados){
                        setModalPrdVisible(false);
                        return;
                    }

                    setDadosDet(dados);
                })
                .catch(function (error) {
                    onCancel(); 
                    setModalPrdVisible(false);
                    console.log(error);
                });
            }       
    }, [id]);

    return (
        <Modal
            title={props.titulo ? <div style={{color: '#666', fontSize: '24px', padding: '15'}}>{props.titulo}</div> : null}
            closable={props.titulo? true : false}
            visible={modalPrdVisible}               
            onCancel={() => cancel()}
            footer={[
                <Button key="back" type="primary" ghost onClick={() => cancel()}>Sair</Button>                    
                ]} 
            width={props.width}
            >
            {
                dadosDet ?
                <WrappedDet dados={dadosDet} {...props} handleChange={(value) => setDadosDet(value)} fetch={fetch} />
                :
                (<div style={{padding:'10px'}}> 
                    <Skeleton active size="small" />
                </div>)
            }        
        </Modal>);
}

export default connect(null, { fetch })(ModalAux);

 